module.exports = __webpack_public_path__ + "static/media/plusicon.1911fa87.svg";